import { FC, PropsWithChildren, forwardRef, useRef, useEffect } from 'react';
import classnames from 'classnames';
import { NavigationItem } from '@src/application/modules/tag/Header/types';
import { useIsMobile } from '@src/application/hooks/useIsMobile';
import { useLocation, useNavigate } from 'react-router-dom';

import styles from './layout.module.scss';
import { Header } from '../../components/Header/Header/Header';
import { SESSION_STORAGE_SAVED_NAV } from '../../components/Header/Navigation/Navigation';

type LayoutBaseProps = {
  HeaderSearchField?: FC;
  navigationItems: NavigationItem[];
};

export const LayoutBase = forwardRef<HTMLDivElement, PropsWithChildren<LayoutBaseProps>>(
  ({ children, HeaderSearchField, navigationItems }, ref) => {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const headerRef = useRef<HTMLDivElement>(null);
    // TO DO Find a way to not render the Header using the route config rather using pathname
    const isMobileDetailsPage = pathname.includes('/details');
    const isMobile = useIsMobile();
    const headerHeight = isMobile ? 115 : 54;

    useEffect(() => {
      try {
        const savedNavigation = window.sessionStorage.getItem(SESSION_STORAGE_SAVED_NAV);
        if (savedNavigation) {
          navigate(savedNavigation);
        } else {
          navigate('/');
        }
      } catch (e) {
        console.error(e);
      }
    }, []);

    return (
      <>
        {!isMobileDetailsPage && (
          <Header ref={headerRef} navigationItems={navigationItems} SearchField={HeaderSearchField} />
        )}
        <div
          className={classnames(styles.body, {
            [styles.mobile]: isMobile,
            [styles.mobileFullPage]: isMobileDetailsPage,
          })}
          style={!isMobileDetailsPage ? { height: `calc(100vh - ${headerHeight}px)` } : { top: 0 }}
          ref={ref}
        >
          {children}
        </div>
      </>
    );
  }
);
